import { render, staticRenderFns } from "./UpdateNote.vue?vue&type=template&id=845a276c"
import script from "./UpdateNote.vue?vue&type=script&lang=ts"
export * from "./UpdateNote.vue?vue&type=script&lang=ts"
import style0 from "./UpdateNote.vue?vue&type=style&index=0&id=845a276c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports